import { Image } from 'expo-image';
import React from 'react';
import { View } from 'react-native';

export interface AppointmentConfirmedTickIconProps {
  size?: number;
}

/**
 * Animated success tick for Appointment Confirmed dialog.
 * Source: assets/images/gif/appointment-confirmed-tick.gif
 */
export function AppointmentConfirmedTickIcon({
  size = 56,
}: Readonly<AppointmentConfirmedTickIconProps>) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Image
        source={require('@assets/images/gif/appointment-confirmed-tick.gif')}
        style={{ width: size, height: size }}
        contentFit="contain"
      />
    </View>
  );
}

export default AppointmentConfirmedTickIcon;
